import { useEffect } from "react";

function App() {
  useEffect(() => {
    const path =
      window.location.pathname + window.location.search + window.location.hash;
    window.location.replace(`https://blithchron.iitgn.ac.in${path}`);
  }, []);

  return null;
}

export default App;
